import { React } from 'react';
import data from './Articles.json';
import './Articles.scss';
import httpService from '../services/httpService';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

const Articles = () => {
    const navigate = useNavigate();
    
    const open = (a) => {

        httpService.register(a.title, () => {
            console.log('registered', a.title);
        }, (e) => {
            console.log('error returned, wait and resend', e);
        }
        );

        window.open(a.link, '_blank', 'noreferrer');

        
    }
   
    return <div className='articles'>

        <div className='article-title'>I write articles for <a className='link' href="https://www.counselling-directory.org.uk/counsellors/isobel-brooks?gad_source=1&gad_campaignid=21293351186&gbraid=0AAAAAD6u42RpcbvRqZkFD7jS7ZkO8pbGE&gclid=CjwKCAiAmePKBhAfEiwAU3Ko3Gn9kY1YY7ZQMpXIOOsseJcSBRWAv2WgqZ0SzbeGb2RYMhUMDydTqhoCaRAQAvD_BwE">Counselling Directory</a>. Here are a selection of articles that I have had published.</div>
        
        <div className="article-items">
            {


              data.map((a, i) => (<div key={i} className='article carousel-cell'
                    onClick={() => open(a)}>
                  <img src={`${import.meta.env.BASE_URL}${a.imageUrl}`} />
                    <span>{a.title}</span>
                </div>
                ))

               
            }
        </div>
        
      
    </div>;
}

export { Articles }

